import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=3f9c5579&scoped=true&"
import script from "./Menus.vue?vue&type=script&lang=js&"
export * from "./Menus.vue?vue&type=script&lang=js&"
import style0 from "./Menus.vue?vue&type=style&index=0&id=3f9c5579&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9c5579",
  null
  
)

export default component.exports